export default __webpack_public_path__ + "static/media/pricingBackground.131849ba.png";